module.exports = __webpack_public_path__ + "0f963d0827ea6e5809b5e36d55185ddd.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/festival.jpg
// module id = 767
// module chunks = 0